import { render, staticRenderFns } from "./recommended-reading.vue?vue&type=template&id=5f2b80e4&scoped=true&"
import script from "./recommended-reading.vue?vue&type=script&lang=js&"
export * from "./recommended-reading.vue?vue&type=script&lang=js&"
import style0 from "./recommended-reading.vue?vue&type=style&index=0&id=5f2b80e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b80e4",
  null
  
)

export default component.exports